import React, { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { deleteTenant } from "../../features/deleteTenant/deleteTenantAction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ConfirmDialog from "../Common/ConfirmDialog";

export default function DataGridComponent(props) {
  const { rows, setRows } = props;
  const [showDeleteModal, setShowDeletemodal] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTenant = rows.find((row) => row.id === selectedTenantId);
  const tenantName = selectedTenant ? selectedTenant.tenant : "";

  const handleCloseModal = () => {
    setShowDeletemodal(false);
    setSelectedTenantId(null);
  };

  const handleOpenModal = (id) => {
    setSelectedTenantId(id);
    setShowDeletemodal(true);
  };

  const handleDelete = () => {
    if (selectedTenantId) {
      dispatch(deleteTenant({ tenantId: selectedTenantId }))
        .then((res) => {
          if (res.type.endsWith('/fulfilled')) {
            const updatedRows = rows.filter(
              (row) => row.id !== selectedTenantId
            );
            setRows(updatedRows);
            toast.success(`Tenant ${tenantName} deleted successfully!`);
            } else if (res.type.endsWith('/rejected')) {
            toast.error(res.payload || "Failed to delete the tenant. Please try again.");
          }
          setShowDeletemodal(false);
        })
        .catch((error) => {
          console.error("Error deleting tenant:", error);
          toast.error("Failed to delete the tenant. Please try again.");
          setShowDeletemodal(false);
        });
    }
  };

  const columns = [
    {
      field: "tenant",
      headerName: "Tenant",
      flex: 1,
      renderCell: (params) => {
        const handleTenantClick = () => {
          const state = {
            tenant: params.row,
          };
          navigate("/tenant/detail", { state });
        };

        return (
          <Box
            sx={{
              cursor: "pointer",
              textDecoration: "none",
              color: "#1976d2",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={handleTenantClick}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.6,
      renderCell: (params) => (
        <Box
          sx={{
            color: params.value === "Active" ? "#11b511" : "red",
            fontWeight: 600,
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 0.6,
    },
    {
      field: "expiration",
      headerName: "Expiration",
      flex: 0.6,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.6,
      renderCell: (params) => (
        <Box>
          <IconButton
            sx={{ color: "#e21616" }}
            onClick={() => handleOpenModal(params.row.id)}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        padding: "10px",
        cursor: "pointer",
        marginTop: "65px",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnMenu
        disableColumnReorder
        disableSelectionOnClick
        pageSizeOptions={[20]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        sx={{
          width: "100%",
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700",
            color: "#1976d2",
          },
        }}
      />
      {showDeleteModal && (
        <ConfirmDialog
          open={showDeleteModal}
          title={`Are you sure you want to delete ${tenantName} tenant?`}
          onConfirm={handleDelete}
          onCancel={handleCloseModal}
        />
      )}
    </Box>
  );
}
